import React, { Component, Fragment } from 'react';
import Navigation from '../components/Navigation';
import { translate } from 'react-i18next';
import axios from 'axios';
import { Panel, Col, Row, Button, FormControl, Form, FormGroup } from 'react-bootstrap';
import HeaderFooterPanel from '../components/HeaderFooterPanel';
import config from '../config';
import qs from 'qs';
import Dropzone from 'react-dropzone';
import TemplateMediaTable from '../components/TemplateMediaTable';
import reorder from '../helpers/reorder';
import { Link } from 'react-router-dom';
import Dialog, { displayName } from 'react-bootstrap-dialog';

import './StudioMediaLibrary.css';

class StudioMediaLibrary extends Component {
	constructor(props) {
		super(props);

		this.state = {
			medialibrary: { name: '' },
			media: [],
			subfolders: [],
			files: [],
			itemsSelected: []
		};
		this.pollingStartTime = null;
		this.polling_timeout = 5 * 60 * 1000; // 5 minutes in milliseconds
	}

	selectionChanged(media, checked) {
		let itemsSelected = this.state.itemsSelected;

		if (checked) {
			itemsSelected.push(media);
		} else {
			itemsSelected = itemsSelected.filter(selectedItem => selectedItem.uuid !== media.uuid);
		}

		var selectedSet = new Set(itemsSelected);

		this.setState({
			itemsSelected: [...selectedSet]
		});
	}

	deleteSelected(media) {
		const { t } = this.props;

		let listedMedia;

		if (media) {
			listedMedia = media.name;
		} else {
			listedMedia = this.state.itemsSelected.map(d => (
				<li key={d.uuid}>
					<strong>{d.name}</strong>
				</li>
			));
		}

		this.dialog.show({
			title: t('Dialog.warning'),
			body: (
				<div>
					{t('Dialog.sure_deletion_items')}
					{listedMedia}
				</div>
			),
			actions: [Dialog.Action(t('Dialog.cancel'), () => console.log('Cancel!'), 'btn-default'), Dialog.Action(t('Dialog.delete'), () => this.didConfirmDelete(), 'btn-danger')],
			bsSize: 'large',
			onHide: dialog => {
				dialog.hide();
			}
		});
	}

	onDeleteMedia(media) {
		const { t } = this.props;

		const listedMedia = (
			<li>
				<strong>{media.name}</strong>
			</li>
		);

		this.dialog.show({
			title: t('Dialog.warning'),
			body: (
				<div>
					{t('Dialog.sure_deletion_items')}
					{listedMedia}
				</div>
			),
			actions: [Dialog.Action(t('Dialog.cancel'), () => 'btn-default'), Dialog.Action(t('Dialog.delete'), () => this.didConfirmDelete(media), 'btn-danger')],
			bsSize: 'large',
			onHide: dialog => {
				dialog.hide();
			}
		});
	}

	reorderMedia(result) {
		const { mediaLibraryUUID } = this.props.match.params;
		const reorderedMedia = reorder(this.state.media, result.source.index, result.destination.index);

		this.setState({
			media: reorderedMedia
		});

		const ordering = {};
		for (var i = 0; i < reorderedMedia.length; i++) {
			const media = reorderedMedia[i];
			ordering[media.uuid] = i;
		}

		try {
			var self = this;
			axios
				.post(`${config.baseURL}/medialibraries/${mediaLibraryUUID}/media/reorder `, { ordering })
				.then(function(response) {
					console.log('Success!');
				})
				.catch(function(err) {
					console.log(err);
				});
		} catch (e) {
			console.log('exception');
		}
	}

	selectAll() {
		this.setState({ itemsSelected: this.state.media });
	}

	selectNone() {
		this.setState({ itemsSelected: [] });
	}

	deleteMedia(media) {
		return new Promise(function(resolve, reject) {
			var self = this;
			axios
				.delete(`${config.baseURL}/media/${media.uuid}`)
				.then(function(result) {
					resolve();
				})
				.catch(function(err) {
					console.log(`Error deleting file: ${media} error: ${err}`);
					reject('error');
				});
		});
	}
	componentDidMount() {
		this.loadStudioMediaLibraryFromServer();
		this.loadStudioMediaLibraryMediaFromServer();
	}

	loadStudioMediaLibraryFromServer() {
		const { mediaLibraryUUID } = this.props.match.params;

		let self = this;
		axios
			.get(`${config.baseURL}/studiolibraries/${mediaLibraryUUID}`, {})
			.then(function(response) {
				self.setState({ medialibrary: response.data.medialibrary });

			})
			.catch(function(error) {
				console.log(error);
			});
	}

	didConfirmDelete(media) {
		let self = this;

		const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

		const promiseSerial = files =>
			files.reduce(function(promise, media) {
				return promise.then(function(result) {
					return Promise.all([delay(250), self.deleteMedia(media)]);
				});
			}, Promise.resolve());

		if (media) {
			self.deleteMedia(media).then(function() {
				self.loadStudioMediaLibraryMediaFromServer();
			});
		} else {
			promiseSerial(this.state.itemsSelected).then(function() {
				console.log('Deleted media');
				self.setState({ itemsSelected: [] });
				self.loadStudioMediaLibraryMediaFromServer();
			});
		}
	}

	loadStudioMediaLibraryMediaFromServer() {
		const { mediaLibraryUUID } = this.props.match.params;

		let self = this;
		axios
			.get(`${config.baseURL}/studiolibraries/${mediaLibraryUUID}/media`, {})
			.then(function(response) {
				let media = response.data.media || [];
				let subfolders = response.data.subfolders || [];

				// Preserve itemsSelected during polling refresh
				self.setState({ media, subfolders });

				let setTimer = false;
				for (const mediaItem of media) {
					if (!mediaItem.uploaded) {
						setTimer = true;
						break;
					}
				}

				// Only continue polling if within timeout window
				if (setTimer) {
					// Start tracking polling time if not already started
					if (!self.pollingStartTime) {
						self.pollingStartTime = Date.now();
					}

					// Check if polling has exceeded timeout
					const pollingDuration = Date.now() - self.pollingStartTime;
					if (pollingDuration < self.polling_timeout) {
						setTimeout(
							function() {
								self.loadStudioMediaLibraryMediaFromServer();
							}.bind(this),
							10000
						);
					} else {
						self.pollingStartTime = null;
					}
				} else {
					// Reset polling timer when all uploads complete
					self.pollingStartTime = null;
				}
			})
			.catch(function(error) {
				console.log(error);
			});
	}

	handleAddSubfolderClicked() {
		const { t } = this.props;

		this.dialog.show({
			body: t('StudioMediaLibrary.subfolder_name'),
			prompt: Dialog.TextPrompt({
				placeholder: t('StudioMediaLibrariesTable.name'),
				initialValue: ''
			}),
			actions: [
				Dialog.Action(t('Dialog.cancel'), () => console.log('Cancel!'), 'btn-default'),
				Dialog.Action(t('StudioMediaLibrary.add_subfolder'), dialog => this.didClickAddSubfolder(dialog.value), 'btn-primary')
			],
			bsSize: 'large',
			onHide: dialog => {
				dialog.hide();
			}
		});
	}

	didClickAddSubfolder(newName) {
		const { mediaLibraryUUID } = this.props.match.params;

		let self = this;
		axios
			.post(`${config.baseURL}/studiolibraries`, {
				name: newName,
				parentUUID: mediaLibraryUUID
			})
			.then(function(response) {
				self.loadStudioMediaLibraryMediaFromServer();
			})
			.catch(function(error) {
				console.log(error);
			});
	}

	onDeleteSubfolder(folder) {
		const { t } = this.props;

		this.dialog.show({
			title: t('Dialog.warning'),
			body: (
				<div>
					{t('StudioMediaLibrary.delete_subfolder_warning')}
					<ul>
						<li><strong>{folder.name}</strong></li>
					</ul>
				</div>
			),
			actions: [
				Dialog.Action(t('Dialog.cancel'), () => console.log('Cancel!'), 'btn-default'),
				Dialog.Action(t('Dialog.delete'), () => this.didDeleteSubfolder(folder), 'btn-danger')
			],
			bsSize: 'large',
			onHide: dialog => {
				dialog.hide();
			}
		});
	}

	didDeleteSubfolder(folder) {
		let self = this;
		axios
			.delete(`${config.baseURL}/studiolibraries/${folder.uuid}`)
			.then(function(response) {
				self.loadStudioMediaLibraryMediaFromServer();
			})
			.catch(function(error) {
				console.log(error);
			});
	}

	renameMedia(media, newName) {
		let self = this;
		axios
			.put(`${config.baseURL}/media/${media.uuid}/name`, { name: newName })
			.then(function(response) {
				self.loadStudioMediaLibraryMediaFromServer();
			})
			.catch(function(error) {
				console.log(error);
			});
	}

	didRenameSubfolder(folder, newName) {
		let self = this;
		axios
			.put(`${config.baseURL}/studiolibraries/${folder.uuid}`, { name: newName })
			.then(function(response) {
				self.loadStudioMediaLibraryMediaFromServer();
			})
			.catch(function(error) {
				console.log(error);
			});
	}

	render() {
		const { t } = this.props;
		const { mediaLibraryUUID } = this.props.match.params;

		const parsed = qs.parse(this.props.location.search.substring(1));
		const rel = parsed.rel;
		document.title = `MySign Digital Screen Solutions | ${t('StudioMediaLibrary.title')}`;

		let createMediaURL = `/studiolibraries/${mediaLibraryUUID}/media/create`;

		const userIsAuthorized = this.props.userIsAuthorized;
		const user = this.props.user;
		const isSuperAdmin = userIsAuthorized(user, ['staff_super_admin']);

		return (
			<div className='StudioMediaLibrary'>
				<Dialog
					ref={el => {
						this.dialog = el;
					}}
				/>
				<div id='wrapper'>
					<Navigation props={this.props} />
					<div id='content-wrapper'>
						<Row>
							<Col lg={12}>
								<h1 className='page-header'>
									{this.state.medialibrary.name}{' '}
									{isSuperAdmin && (
										<Link type='submit' className='btn btn-primary' to={`/studiolibraries/${mediaLibraryUUID}/media/create?rel=studio`}>
											<em className='fa fa-plus fa-fw' /> {t('StudioMediaLibrary.add_media')}
										</Link>
									)}{' '}
									{isSuperAdmin && (
										<Button className='btn btn-primary' onClick={() => this.handleAddSubfolderClicked()}>
											<em className='fa fa-folder-plus fa-fw' /> {t('StudioMediaLibrary.add_subfolder')}
										</Button>
									)}
								</h1>

								<ol className='breadcrumb'>
									<li>
										<i className='fas fa-palette' /> <Link to={`/studiolibraries`}>{t('Navigation.studiolibraries')}</Link>
									</li>
									{this.state.medialibrary.uuid && (this.state.medialibrary.ancestors || []).map(ancestor => (
										<li key={ancestor.uuid}>
											<i className='fas fa-folder' /> <Link to={`/studiolibraries/${ancestor.uuid}?rel=library`}>{ancestor.name}</Link>
										</li>
									))}
									{this.state.medialibrary.uuid && (
										<li className='active'>
											<i className='fas fa-palette' /> {this.state.medialibrary.name}
										</li>
									)}
								</ol>

								<HeaderFooterPanel
									title={t('StudioMediaLibrary.media')}
									headerContent={
										isSuperAdmin && (
											<div className='btn-toolbar pull-right'>
												<Button className='btn-default btn-sm' disabled={false} onClick={() => this.selectAll()}>
													<em className='far fa-check-square' /> {t('StudioMediaLibrary.select_all')}
												</Button>
												<Button className='btn-default btn-sm' disabled={this.state.itemsSelected.length == 0} onClick={() => this.selectNone()}>
													<em className='far fa-square' /> {t('StudioMediaLibrary.select_none')}
												</Button>
												<Button className='btn btn-danger btn-sm' disabled={this.state.itemsSelected.length == 0} onClick={() => this.deleteSelected()}>
													<em className='fa fa-trash' /> {t('StudioMediaLibrary.delete_selected')}
												</Button>
											</div>
										)
									}
								>
									<TemplateMediaTable
										media={this.state.media}
										subfolders={this.state.subfolders}
										subfolderBasePath={'/studiolibraries'}
										onDeleteSubfolder={isSuperAdmin ? (folder => this.onDeleteSubfolder(folder)) : null}
										onRenameSubfolder={isSuperAdmin ? ((folder, newName) => this.didRenameSubfolder(folder, newName)) : null}
										onRenameMedia={isSuperAdmin ? ((media, newName) => this.renameMedia(media, newName)) : null}
										rel={rel}
										medialibraryuuid={mediaLibraryUUID}
										organisationuuid={this.state.medialibrary.organisationUUID}
										onSave={null}
										onDragEnd={isSuperAdmin ? this.reorderMedia.bind(this) : null}
										onCopyClicked={null}
										onTextsClicked={null}
										onSelectionChanged={isSuperAdmin ? this.selectionChanged.bind(this) : null}
										onEnabledChanged={null}
										itemsSelected={this.state.itemsSelected}
										onDeleteMedia={isSuperAdmin ? (media => this.onDeleteMedia(media)) : null}
									/>
								</HeaderFooterPanel>
							</Col>
						</Row>
					</div>
				</div>
			</div>
		);
	}
}

export default translate('translations')(StudioMediaLibrary);
